// NOTE: This is legacy
export enum SubscriptionSKU {
    ProAnnual = "pro-annual",
    ProMonthly = "pro-monthly",
}
